import { render, staticRenderFns } from "./QuestionCircle.vue?vue&type=template&id=21563b50"
import script from "./QuestionCircle.vue?vue&type=script&lang=js"
export * from "./QuestionCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports